module.exports = __webpack_public_path__ + "8f71cd4e52dde0ccfc9b312c71ec1e3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1/public/team/Leadership_Justin_0.jpg
// module id = 467
// module chunks = 0